import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "lock-scroll": false,
    "click-to-close": false,
    "content-class": `modal-container-content ${_ctx.modalContentClass}`,
    style: {"z-index":"99999"}
  }, {
    default: _withCtx(({ close }) => [
      (_ctx.isCloseButton)
        ? (_openBlock(), _createBlock(_component_Image, {
            key: 0,
            class: "close-button clickable",
            src: "svg/ic_cancel",
            extension: "svg",
            onClick: close
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["content-class"]))
}